<template>
    <SidebarItem
        v-if="isCLDomain() && (isCompany() || isCompanyManager() || isCompanyLaborant())"
        icon="orders"
        link="/company/orders"
        :label="$t('admin.sidebar.orders')"
    />
    <SidebarItem v-if="isCLDomain() && (isCompany() || isCompanyManager())" icon="analyzes" link="/company/analyzes" :label="$t('admin.sidebar.analyzes')" />
    <SidebarItem v-if="isCLDomain() && (isCompany() || isCompanyManager())" icon="reports" link="/company/reports" :label="$t('admin.sidebar.reports')" />
    <SidebarItem v-if="isCLDomain() && isCompany()" icon="users" link="/company/users" :label="$t('admin.sidebar.users')" />

    <!-- Message modal -->
    <Modal v-if="isOpen" width="600px" :title="$t(`admin.sidebar.notifications`)" @close="close" :is-open="isOpen">
        <template v-slot:body>
            <h5 class="text-warning">{{ $t('notifs.you_have_an_unaccepted_order') }}</h5>
        </template>
    </Modal>
</template>

<script setup>
    import Modal from '../../custom/Modal.vue';
    import SidebarItem from '@/components/sidebar/SidebarItem.vue';
    import { useClinicOrderNotifyChannel } from '@/services/socket';
    import { isCLDomain, isCompany, isCompanyManager, isCompanyLaborant } from '@/utils/role';
    import { showMessage } from '@/utils/toast';
    import { onMounted } from 'vue';
    import { useModal } from '@/composables/use-modal';
    import { toast } from 'vue3-toastify';
    import { useRoute } from 'vue-router';
    import { useI18n } from 'vue-i18n';
    const { t } = useI18n();

    const { isOpen, open, close } = useModal();
    const route = useRoute();

    onMounted(() => {
        //listen company socket
        if (isCompany() || isCompanyManager() || isCompanyLaborant()) {
            useClinicOrderNotifyChannel(() => {
                if (route.name == 'CompanyOrders') {
                    showMessage(t('notifs.you_have_an_unaccepted_order'), toast.TYPE.WARNING, toast.POSITION.BOTTOM_RIGHT);
                } else {
                    open();
                }
            });
        }
    });
</script>
